import { AnyAction, Dispatch, MiddlewareAPI } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver"

export const mapRoadWorksMiddleware = (store: MiddlewareAPI<Dispatch<AnyAction>, RootState>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    const result = next(action)

    const actionsToWatch = [
        "mapRoadWorks/setMapFiltersState",
        "mapRoadWorks/patchMapFiltersState",
        "mapRoadWorks/resetAllMapFilters",
        "mapRoadWorks/resetSingleMapFilter",
        "mapRoadWorks/setAppliedFilters",
        "mapRoadWorks/setFilterMenuActiveTabs",
    ]

    if (actionsToWatch.includes(action.type)) {
        const state = store.getState()
        const filtersState = state.maps.roadWorks
        const { mapFiltersState, appliedFilters, filterMenuActiveTabs } = filtersState ?? {}

        // Получаем текущий mapsPreferences из хранилища
        const currentMapsPreferences = getItemWebStorage("mapsPreferences") ?? {}

        // Обновляем только ветку WaysideLandLots
        const updatedMapsPreferences = {
            ...currentMapsPreferences,
            RoadWorks: {
                mapFiltersState,
                appliedFilters,
                filterMenuActiveTabs,
            },
        }

        // Сохраняем обратно
        setItemWebStorage('mapsPreferences', updatedMapsPreferences)
    }

    return result
}
